import React, { ChangeEventHandler } from 'react';
import { TextInput, DatePicker, DatePickerInput } from '@carbon/react';
import moment from 'moment';
import { formatDateTime } from '../../helper';

declare type SelectProps = {
    id: string;
    value: any;
    readOnly?: boolean;
    disabled?: boolean;
    onChange: Function;
    textOnly?: boolean;
    labelText: string;
    // [key: string]: any;
    style?: any;
    invalid?: boolean;
    invalidText?: string;
}

function XDDatePicker(props: SelectProps) {
    const { invalid, invalidText, readOnly, disabled, ...rest } = props;

    return (
        <><DatePicker id={props.id} dateFormat="d.m.Y" value={props.value} datePickerType="single" {...rest} onChange={e => props.onChange(e)}>
            <DatePickerInput
                id={`picker_${props.id}`}
                placeholder="d.m.yyyy"
                labelText={props.labelText}
                type="text"
                style={{ width: '100%' }}
                readOnly={readOnly}
                disabled={disabled}
                invalid={invalid}
                invalidText={invalidText}
            />
        </DatePicker>

        </>
    );
}

export default XDDatePicker;
